module.exports = __webpack_public_path__ + "img/team4.8c9baf48.png";